export enum SideNavLabel {
  TEXT_NOTE = "Notes",
  SCREENSHOT_RENDERER = "CMM Screenshot",
  PDF_RENDERER = "Status Letter",
  CASE_SUMMARY = "Case Summary",
  CALLING_SUMMARY = "Calling Summary",
  AUTH = "Auth/Referral",
  SIGNED_COPY = "Signed Copy",
  SFTP_SUMMARY_RESPONSE_STATUS = "Response Status",
  SFTP_SUMMARY_TEXT_NOTES = "Text Notes",
  TASK_HISTORY = "Task History",
  DOCUMENT = "Document",
  DENIAL_LETTER = "Denial Letter",
}
